import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ItemList } from '../../../model';
import { SearchInputTextComponent } from '../../search-input-text/search-input-text.component';

@Component({
  selector: 'ui-search-input',
  templateUrl: './search-input.component.html',
  styleUrls: ['./search-input.component.scss']
})
export class SearchInputComponent implements OnInit {

  /**
   * * Título (opcional).
   */
  @Input() title!: string;

  /**
   * * Texto do hint (opcional).
   */
  @Input() public tooltipText: string = '';

  /**
   * * Texto do Placeholder do Componente (opcional).
   */
  @Input() public placeholderText!: string;

  /**
   * * Indica se o componente está desabilitado.
   */
  @Input() public disabled: boolean = false;

  /**
   * * Evento a ser chamado na alteração do campo de texto.
   */
  @Output() textChangeEvent: EventEmitter<string> = new EventEmitter();

  /**
 * * Lista de resultados encontrados.
 */
  @Input() filterList: ItemList[] = [];

  /**
  * * Indica se o componente deve ser de multi-seleção (padrão: simples).
  */
  @Input() multiSelect: boolean = false;

  /**
  * * Evento a ser emitido ao selecionar algum item.
  */
  @Output() selectChangeEvent = new EventEmitter<ItemList[]>();

  selected!: ItemList[];

  constructor() { }

  ngOnInit(): void {
  }

  onSearch($event: string): void {
    this.textChangeEvent.emit($event);
  }

  onSelect(selected: ItemList[]): void {
    this.selected = selected;
    this.filterList = [];
    this.selectChangeEvent.emit(this.selected);
  }

  get selectedValues(): string {
    return this.selected?.map(s => s.title).toString() ?? '';
  }

  onClear(): void {
    this.onSelect([]);
  }

}
